export default __webpack_public_path__ + "static/media/state-panel-principal.65ea29e6.svg";